import { createActionGroup, emptyProps } from '@ngrx/store';

export const CoreActions = createActionGroup({
  source: 'Core',
  events: {
    'No Action': emptyProps(),
  },
});
